import DeliveryCountries from './AddressStartDeliveryCountries';

class AddressStartApi {
  constructor(addressData) {
    this.type = 'delivery';
    this.addressId = addressData.legacyId;
    this.persistedContactNumber = (window.start.customer && window.start.customer.contactNumber) || '';
    this.initialValues = this._getInitialValues(addressData);
    if (this._isNewAddress()) {
      this.countries = DeliveryCountries.getList();
    }
  }

  _isNewAddress() {
    return !this.addressId;
  }

  _getInitialValues(addressData) {
    return {
      addressId: addressData.legacyId,
      addressLine2: addressData.line2,
      addressee: addressData.addressee,
      companyName: addressData.organisationName,
      contactNumber: addressData.contactNumber || this.persistedContactNumber,
      country: addressData.countryCode,
      countryName: DeliveryCountries.getByCountryCode(addressData.countryCode),
      county: addressData.line4,
      nameNumber: addressData.buildingNameNumber,
      postCode: addressData.postcode,
      streetName: addressData.line1,
      townCity: addressData.line3,
      residentId: addressData.residentId,
      legacyId: '',
      defaultDeliveryAddress: addressData.defaultDeliveryAddress,
      defaultBillingAddress: addressData.defaultBillingAddress,
    };
  }
}

export default AddressStartApi;
